import script from "./start-page.vue?vue&type=script&setup=true&lang=js"
export * from "./start-page.vue?vue&type=script&setup=true&lang=js"

import "./start-page.vue?vue&type=style&index=0&id=17e9e6bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17e9e6bf"]])

export default __exports__